import { Component, Vue, Prop } from "vue-property-decorator";
import { Base64 } from "@/libs/tools";
import { AiCatalog } from "./AiCatalog/index";
import vueScroll from "vuescroll";

@Component({
    components: {
        AiCatalog,
        vueScroll
    }
})
export default class AiSide extends Vue {
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(255, 255, 255, .4)"
        }
    };

    get isAsideHidden() {
        return this.$store.state.aistudy.isAsideHidden;
    }
    private avatar: string = "";
    private nickname: string = "";

    @Prop() readonly catalogs: any;

    mounted() {
        let user = JSON.parse(localStorage.getItem("user"));
        this.avatar = user.avatar
            ? user.avatar
            : "https://asset.greedyai.com/sun/img/defaultAvatar.png";
        this.nickname = Base64.decode(user.nickname);
    }

    handleHiddenAside() {
        this.$store.state.aistudy.isAsideHidden = false;
    }

    handleSectionClick(sectionItem: any, chapterItem: any, calalogList: any) {
        this.$emit("section-click", sectionItem, chapterItem, calalogList);
    }

    handleGuideClick({ chapterItem, section }) {
        this.$emit("guide-click", {
            chapterItem: chapterItem,
            section: section
        });
    }
}

//@ts-ignore
export { default as AiSide } from "./index.vue";
